export default __webpack_public_path__ + "static/media/logo.1a7f9d13.png";